// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"8956ea0e","295":"40321ab6","453":"6fce120c"}[chunkId] + ".chunk.js";
};